<footer>
    <div [@animateFooter]>
        <ul class="footer-left-bar d-none d-md-block">
            <li>
                <a href="https://www.linkedin.com/in/burak-gng/" target='_blank' rel="noopener noreferrer" aria-label="LinkedIn">
                    <i class="fab fa-linkedin-in"></i>
                </a>
            </li>
        </ul>
        <div class="footer-right-bar d-none d-md-block">
            <a href="mailto:burak.gng1@gmail.com" target='_blank'>burak.gng1&#64;gmail.com </a>
        </div>
    </div>

    <div class="footer-credits text-center" >
        <div>Built with Angular by Burak Güngör</div>
    </div>

</footer>
